import { useEffect, useState } from 'react'
import { fetchAuthSession } from 'aws-amplify/auth'
import useAuth from 'hooks/useAuth'

export const useHasPermission = (abr: string): boolean => {
  const { user, isAdmin } = useAuth()
  const [companyAdmin, setCompanyAdmin] = useState(false)

  useEffect(() => {
    let mounted = true
    fetchAuthSession()
      .then((session) => {
        const groups = session.tokens?.idToken?.payload['cognito:groups'] as string[] | undefined
        if (mounted && groups?.includes('company_administrator')) setCompanyAdmin(true)
      })
      .catch(() => undefined)
    return () => {
      mounted = false
    }
  }, [])

  if (isAdmin || companyAdmin) return true
  const policy = user?.currentContract?.role?.permissionPolicy as any
  return Boolean(policy?.[abr])
}
